/* code for cart-drawer /start */
function updateDrawerPosition() {
  const drawer = document.getElementById("sidebar-menu");

  if (window.innerWidth < 768) {
    drawer.setAttribute("open-from", "bottom");
  } else {
    drawer.setAttribute("open-from", "right");
  }
}

updateDrawerPosition();
window.addEventListener("resize", updateDrawerPosition);

/* code for cart-drawer /end */
document.addEventListener("DOMContentLoaded", function () {

  if (document.body.classList.contains('page.dummy-collection')) {

    let slideshow = document.querySelector('.shopify-section--slideshow');
    let categorySlider = document.querySelector('.category-icon-slider');

    if (slideshow && categorySlider) {

      let wrapper = document.createElement('div');
      wrapper.classList.add('first-view-wrapper');

      slideshow.parentNode.insertBefore(wrapper, slideshow);

      wrapper.appendChild(slideshow);
      wrapper.appendChild(categorySlider);

        // document.querySelector('.page.dummy-collection .first-view-wrapper').style.height = `${window.height - 100}px`;
        // const device_height = window
    }

  }
});
document.addEventListener("DOMContentLoaded", function () {
  document.body.classList.add('gender-man');
  document.querySelectorAll('.gender-tab').forEach(tab => {

    tab.addEventListener('click', function (e) {
      e.preventDefault();
      const hideElements = document.querySelectorAll('.custom_slider_men_collection');
      hideElements.forEach(el => {
        if (this.dataset.gender === "women") {
          el.style.display = "none";
           document.body.classList.remove('gender-man');
           document.body.classList.add('gender-women');
        } else {
          el.style.display = "block";
           document.body.classList.add('gender-man');
           document.body.classList.remove('gender-women');
        }
      });

    });

  });

});



// code for button tabs

document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".gender-tab");
  const blocks = document.querySelectorAll(".image-box");

  function filterBlocks(gender) {
    blocks.forEach(block => {
      if (block.dataset.gender === gender) {
        block.style.display = "block";
      } else {
        block.style.display = "none";
      }
    });
  }

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");
      filterBlocks(this.dataset.gender);
    });
  });

  // Default: Men
  filterBlocks("men");
});
// link for home page 
document.addEventListener("DOMContentLoaded", function () {

  const apparels_link = document.querySelector(".apparels_link");
  const accessories = document.querySelector(".accessoeies_link");

  if (apparels_link) {
    apparels_link.addEventListener("click", function () {
      window.location.href = "/pages/apparels";
    });
  }

  if (accessories) {
    accessories.addEventListener("click", function () {
      window.location.href = "/pages/accessories";
    });
  }

});

// Product Page Size Selector Issue Fix 
window.sizeFunction = () => {
    const tempAtc = document.querySelector('.atc_container_temp button');
    const originalAtc = document.querySelector('buy-buttons .atc-container');
    const sizeErrorMessage = document.querySelector('.sizeMessage');
    const buyNowButton = document.querySelector('.buy_now_custom');

    tempAtc.addEventListener('click', function(evt){
      evt.preventDefault();
      const hasSizeSelector = document.querySelector('.swatch-drop-down-wrapper');

      if(!hasSizeSelector){
        originalAtc.querySelector('button').click();
        document.querySelector('.size__Selector_Container').remove();
        originalAtc.closest('.buy-buttons ').classList.remove("hidden");
        return;
      }

      const currentSize = document.querySelector('.swatch-drop-down-inner .swatch-drop-down-list [type="select_value"].swatch-selected')?.value;
      if(isNaN(currentSize)){
        sizeErrorMessage.classList.remove('hidden');
        sizeErrorMessage.style.animation = 'none';
        sizeErrorMessage.offsetHeight;
        sizeErrorMessage.style.animation = null;
      }
      else{
        sizeErrorMessage.classList.add('hidden');
      }
    });

    const bodyObserver = new MutationObserver(() => {
      const list = document.querySelector('.swatch-drop-down-inner .swatch-drop-down-list');
      if (list) {
        bodyObserver.disconnect();
        const liObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if ( mutation.type === "attributes" && mutation.attributeName === "class" && mutation.target.classList.contains("swatch-selected")){
              const selectedLi = mutation.target;
              const selectedValue = selectedLi.getAttribute("value");
              if (!isNaN(selectedValue)) {
                tempAtc.remove();
                // originalAtc.closest('.sticky-wrapper').style.height = 'fit-content';
                originalAtc.closest('.buy-buttons ').classList.remove("hidden");
                sizeErrorMessage.classList.add('hidden');
                
              }
            }
          });
        });
        liObserver.observe(list, {
          subtree: true,
          attributes: true,
          attributeFilter: ["class"]
        });
      }
    });
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    })

    buyNowButton.addEventListener('click', () => {
      document.querySelector('.atc_container_temp button') ? tempAtc.click() : originalAtc.querySelector('button').click();
    })
}

document.addEventListener('DOMContentLoaded', function(){
  window.sizeFunction();
})

// document.querySelector('.atc_container_temp button').addEventListener('click', function () {
//   const msg = document.querySelector('.sizeMessage');

//   msg.classList.remove('hidden');

//   // restart animation
//   msg.style.animation = 'none';
//   msg.offsetHeight; // force reflow
//   msg.style.animation = null;
// });